// Alias
import Item from '../utilities/menu-list/item';

export default Item;
